var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFamily(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.077 5.349a.3.3 0 01.3-.3h2.608a.3.3 0 01.3.3v4.226H4.077V5.35z",
    fill: "#F85757"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.377 10.157l8.67-6.812 8.669 6.812v11H3.376v-11z",
    fill: "#EEE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.046 2l10.825 9.102a.3.3 0 01.042.415l-1.243 1.584a.3.3 0 01-.43.045l-9.194-7.732-9.194 7.732a.3.3 0 01-.43-.045L1.18 11.517a.3.3 0 01.043-.415L12.046 2z",
    fill: "#F66"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.046 4.251l9.942 8.435-.295.407a.3.3 0 01-.436.054l-9.21-7.733-9.192 7.728a.3.3 0 01-.429-.045l-.358-.456 9.978-8.39z",
    fill: "#F85757"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.298 14.85A2.788 2.788 0 017 13.59c0-1.495 1.16-2.706 2.593-2.706 1.09 0 2.024.704 2.407 1.7.383-.996 1.316-1.7 2.407-1.7 1.432 0 2.593 1.211 2.593 2.705 0 .456-.108.885-.298 1.261l-.038.098c-.146.38-.34.741-.578 1.072l-.267.372c-.323.45-.69.865-1.095 1.24l-1.057.981-1.037.841a1 1 0 01-1.26 0l-1.037-.84-1.057-.981a8.294 8.294 0 01-1.095-1.24l-.267-.373a4.747 4.747 0 01-.578-1.072l-.038-.098z",
    fill: "#F66"
  })));
}
export default SvgFamily;